import {
  CardStyled,
  FieldContainer,
  FieldHeader,
  FieldText,
  ImageContainer,
  InfoWithImage,
  Website,
} from './CardEventMobile.style';
import React from 'react';
import { useRouter } from 'next/router';
import { useTheme } from '../../../theme';
import { getStrapiMedia } from '../../../utils/media';
import { Media } from '../../../models/auto-generated-strapi-types/types/Media';
import { DEFAULT_IMAGE } from '../../../models/domain/const';
import ImageWithFallback from '../../image-with-fallback/ImageWithFallback';

export interface CardEventData {
  id: number;
  title: string;
  website?: string;
  image?: any;
  fair: string;
  location: string;
  startDate: string;
  endDate: string;
  stand: string;
  slug: string;
  labelParticipation: string;
  labelNation: string;
  logoPartecipation?: { data: Media };
  logoNation?: { data: Media };
  url: string;
}

interface CardProps {
  data: CardEventData;
  translations: any;
  isPrerenderRequest: boolean;
}

const CardEventMobile: React.FC<CardProps> = ({
  data,
  translations,
  isPrerenderRequest,
}) => {
  const router = useRouter();
  const theme = useTheme();
  const {
    image,
    website,
    fair,
    startDate,
    endDate,
    stand,
    labelParticipation,
    labelNation,
    logoNation,
    logoPartecipation,
    url,
  } = data || {};

  return (
    <CardStyled hasImage={!!image} onClick={() => router.push(url)}>
      {image && image.attributes && (
        <ImageWithFallback
          src={getStrapiMedia(image?.attributes?.url)}
          alt={image?.attributes?.alternativeText || ''}
          layout="intrinsic"
          width={theme.state.theme.spacings.unit(80)}
          height={theme.state.theme.spacings.unit(40.5)}
          objectFit="contain"
          fallbackSrc={DEFAULT_IMAGE}
          isPrerenderRequest={isPrerenderRequest}
        />
      )}
      {website && <Website>{website}</Website>}
      <FieldContainer>
        <FieldHeader>
          {translations?.pages?.newsEvents?.pastEventsSlider?.fair}
        </FieldHeader>
        <FieldText>{fair ?? ''}</FieldText>
      </FieldContainer>
      <FieldContainer>
        <FieldHeader>
          {translations?.pages?.newsEvents?.pastEventsSlider?.date}
        </FieldHeader>
        <FieldText>
          {startDate ?? 'N/A'} - {endDate ?? 'N/A'}
        </FieldText>
      </FieldContainer>
      <FieldContainer>
        <FieldHeader>
          {translations?.pages?.newsEvents?.pastEventsSlider?.stand}
        </FieldHeader>
        <FieldText>{stand ?? ''}</FieldText>
      </FieldContainer>
      <FieldContainer>
        <FieldHeader>
          {translations?.pages?.newsEvents?.pastEventsSlider?.participation}
        </FieldHeader>
        <InfoWithImage>
          {logoPartecipation?.data?.attributes?.url && (
            <ImageContainer>
              <ImageWithFallback
                layout="fill"
                objectFit="contain"
                src={getStrapiMedia(
                  logoPartecipation?.data?.attributes?.url ?? ''
                )}
                alt={logoPartecipation?.data?.attributes?.alternativeText || ''}
                fallbackSrc={DEFAULT_IMAGE}
                isPrerenderRequest={isPrerenderRequest}
              />
            </ImageContainer>
          )}
          <FieldText>
            {labelParticipation
              ? labelParticipation
              : logoPartecipation?.data?.attributes?.url
                ? ''
                : '-'}
          </FieldText>
        </InfoWithImage>
      </FieldContainer>
      <FieldContainer>
        <FieldHeader>
          {translations?.pages?.newsEvents?.pastEventsSlider?.nation}
        </FieldHeader>
        <InfoWithImage>
          {logoNation?.data?.attributes?.url && (
            <ImageContainer>
              <ImageWithFallback
                layout="fill"
                objectFit="contain"
                src={getStrapiMedia(logoNation?.data?.attributes?.url ?? '')}
                alt={logoNation?.data?.attributes?.alternativeText || ''}
                fallbackSrc={DEFAULT_IMAGE}
                isPrerenderRequest={isPrerenderRequest}
              />
            </ImageContainer>
          )}

          <FieldText>
            {labelNation
              ? labelNation
              : logoNation?.data?.attributes?.url
                ? ''
                : '-'}
          </FieldText>
        </InfoWithImage>
      </FieldContainer>
    </CardStyled>
  );
};

export default CardEventMobile;
